'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _commonFunctions = require('../../helpers/commonFunctions');

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (formConfig, formValues) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  additional_data.mq_answers = [].concat(_toConsumableArray(formValues.applicant.map(function (applicants) {
    return [applicants.additional_data.mq.mq1, applicants.additional_data.mq.mq2, applicants.additional_data.mq.mq3, applicants.additional_data.mq.mq4, applicants.additional_data.mq.mq5, applicants.additional_data.mq.mq6, applicants.additional_data.mq.mq7, applicants.additional_data.mq.mq8];
  })));

  additional_data.is_smoker = formValues.applicant[0].additional_data.mq.mq8;
  additional_data.payment_option = formValues.payment.payment_option;
  additional_data.coverage = '25000';

  return _extends({}, (0, _commonFunctions.transformApplication)(formValues), {
    expiry_date: (0, _moment2.default)(effective_date).add(364 + _dateFunctions2.default.getLeapYearDay(effective_date, 364), 'days').format('YYYY-MM-DD')
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/rimisecureadvantageplus/application.js
// module id = 1754
// module chunks = 0